import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class LandingPageRoute extends AuthenticatedRoute {}
